export default __webpack_public_path__ + "static/media/order_item.1991ca12.svg";